<template>
  <div class="mobile-onboarding">
    <div class="mobile-onboarding__body">
      <div
        class="close"
        @click="handleClickClose"
      />

      <div
        v-show="onboardingPhase === 0"
        class="first-page"
      >
        <h1>환영합니다!</h1>

        <div class="description">
          피플박스 이용 전 기본 설정이 필요합니다. <br>
          다음에 안내되는 가이드를 따라 <br>
          기본 설정을 마쳐주시길 바랍니다.
        </div>
        <div class="guide">
          원활한 진행을 위해 PC 이용을 권장드립니다.
        </div>
      </div>

      <div
        v-show="onboardingPhase === 1"
        ref="swiperContainer"
        class="swiper-container"
      >
        <div
          ref="pagination"
          class="swiper-pagination"
        />
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <h1>운영 정책을 설정해주세요.</h1>
            <div
              class="onboarding-image"
              style="background-image: url(&quot;/image/onboarding/1.png&quot;);"
            />
            <div class="guide">
              예약제가 아닐 경우 이 단계는 스킵하시면 됩니다.
            </div>
          </div>
          <div class="swiper-slide">
            <h1>강사를 등록해주세요.</h1>
            <div
              class="onboarding-image"
              style="background-image: url(&quot;/image/onboarding/2.png&quot;);"
            />
          </div>
          <div class="swiper-slide">
            <h1>회원권을 등록해주세요.</h1>
            <div
              class="onboarding-image"
              style="background-image: url(&quot;/image/onboarding/3.png&quot;);"
            />
          </div>
          <div class="swiper-slide">
            <h1>수업을 개설해주세요.</h1>
            <div
              class="onboarding-image"
              style="background-image: url(&quot;/image/onboarding/4.png&quot;);"
            />
          </div>
          <div class="swiper-slide">
            <h1>스케줄을 등록해주세요.</h1>
            <div
              class="onboarding-image"
              style="background-image: url(&quot;/image/onboarding/5.png&quot;);"
            />
          </div>
          <div class="swiper-slide">
            <h1>회원을 등록해주세요.</h1>
            <div
              class="onboarding-image"
              style="background-image: url(&quot;/image/onboarding/7.png&quot;);"
            />
            <div class="guide">
              피플박스 앱을 통해 회원이 직접 가입할 수도 있습니다.
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="onboardingPhase === 2"
        class="first-page"
      >
        <h1>이제 시작해보세요!</h1>

        <div class="description">
          회원 50인까지 전 기능 무료 이용이 가능합니다. <br>
          이용 중 문의 사항은 언제든지 <br>
          좌측 하단 '지원' 버튼을 눌러 접수해주세요.
        </div>
        <div
          class="guide underlined"
          @click="goBasicGuide"
        >
          가이드 처음부터 다시 보기
        </div>
      </div>
    </div>
    <div class="mobile-onboarding__controller">
      <div v-show="onboardingPhase === 0">
        <el-button
          class="default"
          @click="goBasicGuide"
        >
          기본 설정 가이드 <strong>보기</strong>
        </el-button>
      </div>
      <div v-show="onboardingPhase === 2">
        <el-button
          class="default"
          @click="goBasicSetting"
        >
          기본 설정하러 가기
        </el-button>
      </div>
      <div
        v-show="onboardingPhase === 1 && swiperIndex > 0"
        class="mobile-onboarding__two-button"
      >
        <el-button
          class="default lg-inverted-gray"
          @click="slidePrev"
        >
          이전
        </el-button>
        <el-button
          class="default"
          @click="slideNext"
        >
          {{ swiperIndex === 4 ? '완료' : '다음' }}
        </el-button>
      </div>
      <div v-show="onboardingPhase === 1 && swiperIndex === 0">
        <el-button
          class="default"
          @click="slideNext"
        >
          다음
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

export default {
	name: "MobileOnboardingPage",
	data() {
		return {
			onboardingPhase: 0,
			swiper: null,
			swiperIndex: 0,
		};
	},
	computed: {},
	methods: {
		goBasicGuide() {
			this.onboardingPhase = 1;
			this.swiperIndex = 0;
			this.$nextTick(() => {
				this.swiper = new Swiper(this.$refs.swiperContainer, {
					pagination: {
						el: this.$refs.pagination,
					},
					on: {
						slideChangeTransitionEnd: () => {
							this.swiperIndex = this.swiper.activeIndex;
						},
					},
				});
			});
		},
		handleClickClose() {
			this.$router.push("dashboard").catch(()=>{});
		},
		goBasicSetting() {
			this.$router.push("setting/policy").catch(()=>{});
		},
		slideNext() {
			if (this.swiperIndex === 4) {
				return (this.onboardingPhase = 2);
			}

			this.swiper.slideNext();
		},
		slidePrev() {
			this.swiper.slidePrev();
		},
	},
};
</script>
<style lang="scss">
.mobile-onboarding {
	width: 100%;
	height: 100%;
	background-color: #797979;
	display: flex;
	flex-direction: column;

	.mobile-onboarding__body {
		height: calc(100% - 80px);

		.close {
			background-image: url("/image/icon/close.svg");
			background-repeat: no-repeat;
			background-position: center;
			width: 20px;
			height: 20px;
			position: absolute;
			right: 20px;
			top: 20px;
			z-index: 9999;
		}

		.first-page {
			width: 100%;
			height: 100%;
			padding-top: 111px;
			display: flex;
			flex-direction: column;
			box-sizing: border-box;
			position: relative;
		}

		h1 {
			line-height: 37px;
			font-size: 25px;
			font-weight: normal;
			letter-spacing: -1px;
			text-align: center;
			color: #ffffff;
			margin: 0 0 20px;
		}

		.description {
			font-size: 15px;
			font-weight: normal;
			line-height: 22px;
			letter-spacing: -0.8px;
			text-align: center;
			color: #ffffff;
		}

		.swiper-container {
			width: 100%;
			height: 100%;
		}

		.swiper-slide {
			padding-top: 70px;
			text-align: center;
			font-size: 18px;
			display: flex;
			justify-content: start;
			align-items: center;
			flex-direction: column;
			position: relative;
			box-sizing: border-box;
		}

		.onboarding-image {
			width: 100%;
			flex: auto;
			margin-bottom: 35px;
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
		}

		.guide {
			line-height: 20px;
			font-size: 12px;
			font-weight: 500;
			letter-spacing: -0.5px;
			text-align: center;
			color: #ffffff;
			margin-bottom: 15px;
			width: 100%;
			position: absolute;
			bottom: 0;
			left: 0;

			&.underlined {
				text-decoration: underline white;
			}
		}

		.swiper-container-horizontal > .swiper-pagination-bullets {
			bottom: unset;
			top: 20px;
			left: 0;
			width: 100%;

			.swiper-pagination-bullet-active {
				opacity: 1;
				background: #f2f2f2;
			}
		}
	}

	.mobile-onboarding__controller {
		height: 80px;
		padding: 0 40px;
		flex: initial;

		.mobile-onboarding__two-button {
			.el-button:first-child {
				width: calc(40% - 10px);
			}

			.el-button:last-child {
				width: 60%;
			}
		}
	}
}
</style>
